<button data-toggle="tooltip" type="button" placement="top" [ngbTooltip]="titleTemplate">
    <svg data-html="true" class="svg-icon svg-question-circle" aria-hidden="true" focusable="false">
        <use xlink:href="../../../assets/svg-icons/icon-sprite.svg#question-circle"></use>
    </svg>
</button>

<ng-template #titleTemplate>
    <span>{{ title }}</span>
</ng-template>
